import { throttle } from 'lodash';

import { initializeAOS, toggleAOSAnimations } from './modules/aos-setup.js';
import { initializeNavbar } from './modules/navbar.js';
import { initializeRunningText } from './modules/running-text.js';
import { initializeCounterAnimation } from './modules/counter-animation.js';
import { initializeTextSlider, showTextSlide, changeTextSlide } from './modules/text-slider.js';
import { initializeGlowPoints } from './modules/glow-points.js';
import { initializeHeroSlider } from './modules/simple-hero-slider.js';
import { initializeDropdowns } from './modules/dropdowns.js';
import { initializeTooltips } from './modules/tooltips.js';
import { initializeTimeline } from './modules/timeline.js';
import { initializeBarba } from './modules/barba.js';

const ERROR_MESSAGES = {
	INIT_FAILED: 'Application: Failed to initialize components',
	SCROLL_ERROR: 'Application: Error handling scroll',
};

// Make the text slider functions available globally
window.showTextSlide = showTextSlide;
window.changeTextSlide = changeTextSlide;

/**
 * Initialize all components
 * @returns {void}
 */
export const initializeComponents = () => {
	try {
		// Initialize AOS
		initializeAOS();

		// Initialize navigation components
		initializeNavbar();
		initializeDropdowns();

		// Initialize text components
		initializeRunningText();
		initializeTextSlider();

		// Initialize animations
		initializeCounterAnimation();
		initializeGlowPoints();
		initializeHeroSlider();
		initializeTimeline();

		// Initialize UI components
		initializeTooltips();

		const toggleButton = document.getElementById('toggleAOS');
		if (toggleButton) {
			toggleButton.addEventListener('click', toggleAOSAnimations);
		}

	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

/**
 * Handle scroll events for navbar
 * @returns {void}
 */
const handleScroll = () => {
	try {
		initializeNavbar();
	} catch (error) {
		console.error(ERROR_MESSAGES.SCROLL_ERROR, error);
	}
};



export const loadHubspotFormIfPresent = () => {
	// Only run if the container exists
	var formContainer = document.querySelector('.form-body');
	if (formContainer && typeof hbspt !== "undefined") {
		// Prevent double-loading
		// grab the form id from the data attribute
		var formId = formContainer.attributes['data-form'] ? formContainer.attributes['data-form'].value : 'n/a';
		if (!formContainer.dataset.hubspotLoaded) {
			hbspt.forms.create({
				portalId: "20675274",
				formId: formId,
				region: "na1",
				target: ".form-body"
			});
			formContainer.dataset.hubspotLoaded = "true";
		}
	}
};


// Initialize Barba.js first
initializeBarba();

// Initialize components when DOM is ready
document.addEventListener('DOMContentLoaded', initializeComponents);
document.addEventListener('DOMContentLoaded', loadHubspotFormIfPresent);

// Throttle scroll event for better performance
window.addEventListener('scroll', throttle(handleScroll, 100));

// Throttle resize event for running text
window.addEventListener('resize', throttle(initializeRunningText, 250));
